export const LOGINING_USER = 'LOGINING_USER'

export const IS_LOGIN = 'IS_LOGIN'
